import PropTypes from "prop-types"
import { map } from "lodash"
import { Fade, CardContent } from "@mui/material"
import Trade from "./trade"
import { TRADE } from "../../shapes"
import "./styles.scss"

function Trades({ trades, openSecurityProfile, openTradeId, constraints, setTradeConstraint, setOpenTradeId, openFactorProfile }) {
  const computedTrades = map(trades, trade => <Trade
    trade={trade}
    key={trade.key}
    openTradeId={openTradeId}
    constraints={constraints}
    setTradeConstraint={setTradeConstraint}
    setOpenTradeId={setOpenTradeId}
    openSecurityProfile={openSecurityProfile}
    openFactorProfile={openFactorProfile}
  />)
  return <Fade in>
    <CardContent className="trades">
      <div className="header">
        <div className="ticker">Ticker</div>
        <div className="equity">% Equity</div>
      </div>
      {computedTrades.length > 0 ? computedTrades : <div className="no-trade-label">No trade to display</div>}
    </CardContent>
  </Fade>
}

Trades.propTypes = {
  trades: PropTypes.arrayOf(TRADE).isRequired,
  allPositions: PropTypes.arrayOf(TRADE).isRequired,
  openTradeId: PropTypes.string,
  constraints: PropTypes.object.isRequired,
  setTradeConstraint: PropTypes.func.isRequired,
  setOpenTradeId: PropTypes.func.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
}

export default Trades
